import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [40.76774, -73.978747, 22],
  [40.767675, -73.978618, 21.8],
  [40.767616, -73.978484, 21.8],
  [40.76756, -73.978356, 21.8],
  [40.767504, -73.978227, 21.8],
  [40.767453, -73.978103, 21.8],
  [40.767404, -73.977969, 21.8],
  [40.767359, -73.977841, 21.8],
  [40.767308, -73.977706, 21.8],
  [40.767268, -73.977572, 21.8],
  [40.767225, -73.977444, 21.8],
  [40.767193, -73.977304, 21.8],
  [40.767171, -73.977165, 22],
  [40.76716, -73.977031, 22],
  [40.767163, -73.976891, 22],
  [40.767187, -73.976757, 22.2],
  [40.767233, -73.976634, 22.2],
  [40.767289, -73.976521, 22.2],
  [40.767359, -73.976419, 22.4],
  [40.767442, -73.976333, 22.4],
  [40.767531, -73.976269, 22.6],
  [40.767622, -73.976215, 22.6],
  [40.767716, -73.976161, 22.6],
  [40.767807, -73.976113, 22.6],
  [40.767906, -73.97606, 22.8],
  [40.768, -73.976006, 22.6],
  [40.768091, -73.975952, 22.6],
  [40.768182, -73.975899, 22.6],
  [40.768273, -73.97584, 22.4],
  [40.768365, -73.975781, 22.4],
  [40.768464, -73.975711, 22.2],
  [40.76856, -73.975646, 22],
  [40.768652, -73.975587, 21.8],
  [40.768751, -73.975528, 21.6],
  [40.768845, -73.975459, 21.4],
  [40.768941, -73.975389, 21.2],
  [40.769041, -73.975319, 21],
  [40.769134, -73.975244, 20.8],
  [40.769231, -73.975158, 20.6],
  [40.769322, -73.975078, 20.6],
  [40.769411, -73.974987, 20.4],
  [40.769494, -73.974879, 20.2],
  [40.769574, -73.974777, 20],
  [40.769655, -73.97467, 20],
  [40.76973, -73.974558, 20],
  [40.769802, -73.97445, 20.2],
  [40.769867, -73.974338, 20.6],
  [40.769915, -73.974209, 21.4],
  [40.769936, -73.974085, 22],
  [40.769947, -73.973957, 22.4],
  [40.769944, -73.973833, 22.6],
  [40.769926, -73.97371, 23],
  [40.769899, -73.973597, 23.2],
  [40.769864, -73.97349, 23.4],
  [40.769821, -73.973383, 23.6],
  [40.769781, -73.973286, 23.8],
  [40.769735, -73.973184, 23.8],
  [40.769692, -73.973088, 24],
  [40.769647, -73.972986, 24.2],
  [40.769601, -73.972889, 24.4],
  [40.769558, -73.972782, 24.4],
  [40.769523, -73.97268, 24.6],
  [40.769494, -73.972567, 24.8],
  [40.769478, -73.972455, 25],
  [40.769475, -73.972337, 25],
  [40.769486, -73.972224, 25.2],
  [40.76951, -73.972117, 25.2],
  [40.769548, -73.972009, 25.2],
  [40.769601, -73.971918, 25.2],
  [40.769663, -73.971816, 25],
  [40.769727, -73.971736, 25],
  [40.769792, -73.971645, 24.8],
  [40.769864, -73.971553, 24.6],
  [40.769939, -73.971468, 24.4],
  [40.77002, -73.971382, 24.4],
  [40.770105, -73.971307, 24.8],
  [40.770191, -73.971237, 25.2],
  [40.77028, -73.971183, 25.4],
  [40.770363, -73.971124, 25.4],
  [40.770451, -73.971065, 25.4],
  [40.770535, -73.971012, 25.4],
  [40.770623, -73.970947, 25.6],
  [40.770712, -73.970888, 25.6],
  [40.770797, -73.970835, 25.6],
  [40.770878, -73.970765, 25.6],
  [40.770958, -73.97069, 25.8],
  [40.771031, -73.970604, 26],
  [40.771095, -73.970513, 26.2],
  [40.771157, -73.970416, 26.4],
  [40.771219, -73.970325, 26.4],
  [40.771272, -73.970218, 26.4],
  [40.771326, -73.970116, 26.4],
  [40.771379, -73.970008, 26.8],
  [40.771433, -73.969912, 27],
  [40.771481, -73.969805, 27.4],
  [40.771532, -73.969708, 27.6],
  [40.771581, -73.969612, 27.8],
  [40.771634, -73.96952, 28],
  [40.771691, -73.969429, 28.2],
  [40.771755, -73.969354, 28.4],
  [40.771827, -73.969279, 28.4],
  [40.771903, -73.969225, 28.4],
  [40.771986, -73.969166, 28.4],
  [40.772069, -73.969113, 28.2],
  [40.772152, -73.969064, 28.2],
  [40.772246, -73.969021, 28],
  [40.772337, -73.968973, 27.8],
  [40.772428, -73.968925, 27.6],
  [40.772522, -73.968882, 27.6],
  [40.772619, -73.968834, 27.4],
  [40.772721, -73.968812, 27.2],
  [40.772828, -73.968807, 26.8],
  [40.772935, -73.968828, 26],
  [40.773045, -73.968871, 24.8],
  [40.773155, -73.968936, 24],
];

export default stream;
